import { useState, useContext, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import AuthContext from "../../../context/auth/AuthContext";
import moment from "moment";
import useTranslator from "../../../hooks/useTranslator";
import constants from "../../../Utils/constants";
import {
  getUserDisplayName,
  haveValue,
  placeNotificationLink,
  toast,
} from "../../../helper/common";

const Notification = () => {
  const nexticon = "/images/arrow-right.svg";
  const { _t } = useTranslator();
  const { hash } = useLocation();
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { workspaceId } = useParams();
  const {
    user,
    notifications,
    userType,
    notificationSeen,
    loadMyNotifications,
  } = authContext;

  const [buttoninfo, setButtonInfo] = useState({
    buttonText: "",
    buttonLink: "",
  });

  useEffect(() => {
    if (hash == "#already_awarded") {
      toast.error(_t("youAreAlreadyAwardedAProperty"));
      navigate(
        haveValue(workspaceId)
          ? `/${workspaceId}/notification`
          : "/notification"
      );
    }
    if (hash == "#no_longer_available") {
      toast.error(_t("thisPropertyIsNoLongerAvailable"));
      navigate(
        haveValue(workspaceId)
          ? `/${workspaceId}/notification`
          : "/notification"
      );
    }
  }, [hash]);

  useEffect(() => {
    if (userType == "landlord") {
      setButtonInfo({ ...buttoninfo, buttonText: _t("sendPropertyLink") });
    }
    if (userType == "tenant") {
      setButtonInfo({ ...buttoninfo, buttonText: _t("propertyInfo") });
    }
    let userid = localStorage.getItem("saveduserid");
    loadMyNotifications(userid, userType);
  }, []);

  const checkSeen = (val, noti) => {
    if (val) {
      return "Notifications-wapper";
    } else {
      return "Notifications-wapper bg-wapper";
    }
  };

  const onNotiClick = (notification) => {
    if (notification?.shared_profile_id?.pendingDecision === true) {
      toast.error(_t("pendingDecisionFromTenant"));
      return;
    }
    notificationSeen(notification?._id);
  };

  return (
    <div className="main-page-wrapper main-notification">
      <div className="tabs-box-pattern tabs-box-pattern-2">
        <div className="tabs-item d-block padding-full-zero">
          <div className="header-edit text-center d-flex items-center justify-content-between">
            <h3 className="mb-0">{_t("notifications")}</h3>
          </div>
          <div
            className={`Notifications-row ${notifications.length == 0 && "d-flex justify-content-center align-items-center"}`}
          >
            {notifications.length == 0 && (
              <>
                {" "}
                <p style={{ textAlign: "center" }}>
                  {" "}
                  {_t("youHaveNotReceivedAnyNotificationsYet")}
                </p>
              </>
            )}

            {notifications &&
              notifications.map((notification, index) => (
                <Link
                  to={placeNotificationLink(notification, workspaceId)}
                  onClick={() => onNotiClick(notification)}
                  className={`${
                    !notification?.marked_read ? "notificationNotRead" : ""
                  }`}
                >
                  <div
                    key={index}
                    className={checkSeen(
                      notification?.marked_read,
                      notification
                    )}
                  >
                    <div className="notification-leftbar">
                      {[
                        "insurance_pending_contract",
                        "insurance_pending_contract_reminder",
                      ].includes(notification?.notification_type) ? (
                        <h4>Skor</h4>
                      ) : userType === "tenant" &&
                        notification?.notification_type !=
                          "guarantor_declined" ? (
                        <>
                          <h4>
                            {notification?.landlord_fname}{" "}
                            {notification?.landlord_lname}{" "}
                            <span>
                              (
                              {notification?.created_by_landlord
                                ?.landlordtype == "agent"
                                ? _t("agent")
                                : _t("landlord")}
                              )
                            </span>
                          </h4>
                        </>
                      ) : (
                        <>
                          <h4>
                            {getUserDisplayName(
                              notification?.created_by_tenant,
                              ""
                            )}
                            <span>({_t("tenant")})</span>
                          </h4>
                        </>
                      )}

                      <p key={index}>
                        {(() => {
                          switch (notification?.notification_type) {
                            case "guarantor_removed":
                              const splited = notification?.body.split(" ");
                              return `${splited[0]} ${splited[1]} ${_t(
                                "hasRemovedHimselfAsAGuarantorFor"
                              )} ${
                                notification?.shared_profile_id?.tenant_fname
                              } ${
                                notification?.shared_profile_id?.tenant_lname
                              }`;

                            case "guarantor_declined":
                              return `${_t("guarantorRequestDeclinedBy")} ${
                                notification?.created_by_tenant?.fname
                              } ${notification?.created_by_tenant?.lname}`;

                            case "property_assigned":
                              return `${
                                notification?.created_by_landlord
                                  ?.fname_companyName
                              } ${_t("hasAwardedYouAProperty")}`;

                            case "profile_linked":
                              return `${
                                notification?.created_by_landlord
                                  ?.fname_companyName
                              } ${_t("hasLinkedYourProfileToAAddress")}.`;

                            case "profile_sharing":
                              return `${
                                notification?.created_by_tenant?.fname
                              } ${_t("hasSharedProfileWithYou")}`;

                            case "document_updated":
                              return `${
                                notification?.created_by_tenant?.fname
                              } ${notification?.created_by_tenant?.lname} ${_t(
                                "hasUpdatedTheirDocuments"
                              )}`;

                            case "guarantor_document_updated":
                              return `${
                                notification?.created_by_tenant?.fname
                              } ${
                                notification?.created_by_tenant?.lname
                              }'s ${_t("guarantor")} ${_t(
                                "hasUpdatedTheirDocuments"
                              )}`;

                            case "guarantor_added":
                              return `${
                                notification?.created_by_tenant?.fname
                              } ${notification?.created_by_tenant?.lname} ${_t(
                                "hasAddedNewGuarantor"
                              )}`;

                            case "financial_info_updated":
                              return `${
                                notification?.created_by_tenant?.fname
                              } ${notification?.created_by_tenant?.lname} ${_t(
                                "hasUpdatedTheirFinancialInformation"
                              )}`;

                            case "financial_info_updated_guarantor":
                              return `${
                                notification?.created_by_tenant?.fname
                              } ${
                                notification?.created_by_tenant?.lname
                              }'s guarantor ${_t(
                                "hasUpdatedTheirFinancialInformation"
                              )}`;
                            case "client_identification_signature_requested":
                              return notification?.body;
                            case "profile_sharing_accepted":
                              //   body: `Tenant ${request.tenant_id.fname} ${request.tenant_id.lname} profile was shared with WS ${workspaceData.name}`,
                              return `Tenant ${getUserDisplayName(
                                notification?.created_by_tenant
                              )} ${notification?.shared_profile_id?.application_id?.title ? `${"'s"} ${_t("application")} ${notification?.shared_profile_id?.application_id?.title}` : ""}
                                 ${_t("wasSharedWithWS")} 
                                 ${notification.workspaceId.name}`;
                            case "insurance_pending_contract": {
                              return `${_t("paymentReceivedFor")} ${notification?.body}. ${_t("addBeneficiaryChoosePolicyStartAndUploadContract")}`;
                            }
                            case "insurance_pending_contract_reminder": {
                              return `${_t("reminderCompleteInsuranceFor")} ${notification?.body} ${_t("byAddingBeneficiaryStartDateAndContract")}`;
                            }
                            default:
                              return notification?.body;
                          }
                        })(notification)}
                      </p>
                    </div>

                    <div className="notification-rightbar">
                      <h6>
                        {moment(notification?.createdAt).format("DD/MM/YYYY")}
                      </h6>
                      {notification?.notification_type == "profile_sharing" ? (
                        <Link
                          to={`/${workspaceId}/profile-property?sharedprofileid=${notification?.shared_profile_id?._id}`}
                        >
                          <img src={nexticon} alt="" />
                        </Link>
                      ) : null}
                      {notification.body.includes("basic") ? (
                        <Link to={`/tenant-basic-profile/${notification._id}`}>
                          <img src={nexticon} alt="" />
                        </Link>
                      ) : null}
                      {notification.body.includes("sent") ? (
                        <Link
                          to={`/send-link?sharedprofileid=${notification?.shared_profile_id?._id}`}
                        >
                          <img src={nexticon} alt="" />
                        </Link>
                      ) : null}
                      {notification?.notification_type ==
                      "property_assigned" ? (
                        <Link
                          to={`/accept/assigned/property/${notification?.assigned_property_id?._id.toString()}`}
                        >
                          <img src={nexticon} alt="" />
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </Link>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notification;
